/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-employee.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../../../app/modules/employee/pages/employees/select-employee/select-employee.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../../app/modules/employee/service/employee/employee.service';
const styles_SelectEmployeeComponent:any[] = [i0.styles];
export const RenderType_SelectEmployeeComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectEmployeeComponent,data:{}});
function View_SelectEmployeeComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,
          [8,(null as any)]],{value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),
          0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],{value:[0,'value']},
          (null as any)),(_l()(),i1.ɵted(3,(null as any),['','']))],(_ck,_v) => {
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.selected;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_3);
  });
}
export function View_SelectEmployeeComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['input',
      1]],(null as any),4,'select',[['class','form-control']],(null as any),[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.SelectEmployeeComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.change($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectEmployeeComponent_1)),
      i1.ɵdid(4,802816,(null as any),0,i4.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.SelectEmployeeComponent = _v.component;
    const currVal_0:any = _co.employeeOptions;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_SelectEmployeeComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-select-employee',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectEmployeeComponent_0,
      RenderType_SelectEmployeeComponent)),i1.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i3.SelectEmployeeComponent]),i1.ɵdid(2,114688,(null as any),0,i3.SelectEmployeeComponent,
      [i1.Renderer2,i5.EmployeeService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const SelectEmployeeComponentNgFactory:i1.ComponentFactory<i3.SelectEmployeeComponent> = i1.ɵccf('app-select-employee',
    i3.SelectEmployeeComponent,View_SelectEmployeeComponent_Host_0,{employeeId:'employeeId',
        employeePosition:'employeePosition'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZW1wbG95ZWVzL3NlbGVjdC1lbXBsb3llZS9zZWxlY3QtZW1wbG95ZWUuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2VtcGxveWVlcy9zZWxlY3QtZW1wbG95ZWUvc2VsZWN0LWVtcGxveWVlLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2VtcGxveWVlcy9zZWxlY3QtZW1wbG95ZWUvc2VsZWN0LWVtcGxveWVlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvZW1wbG95ZWVzL3NlbGVjdC1lbXBsb3llZS9zZWxlY3QtZW1wbG95ZWUuY29tcG9uZW50LnRzLlNlbGVjdEVtcGxveWVlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNlbGVjdCAjaW5wdXQgKGNoYW5nZSk9XCJjaGFuZ2UoJGV2ZW50KVwiIGNsYXNzPVwiZm9ybS1jb250cm9sXCI+XHJcbiAgICA8b3B0aW9uIHZhbHVlPVwie3tlbXBsb3llZS5pZH19XCIgKm5nRm9yPVwibGV0IGVtcGxveWVlIG9mIGVtcGxveWVlT3B0aW9uc1wiIFtzZWxlY3RlZF09XCJlbXBsb3llZS5zZWxlY3RlZFwiPnt7ZW1wbG95ZWUubmFtZX19PC9vcHRpb24+XHJcbjwvc2VsZWN0PlxyXG4iLCI8YXBwLXNlbGVjdC1lbXBsb3llZT48L2FwcC1zZWxlY3QtZW1wbG95ZWU+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0NJO01BQUE7YUFBQTtVQUFBLDZEQUFBO1VBQUE7VUFBQSxlQUF3RztJQUFoRztJQUFSLFdBQVEsU0FBUjtJQUFRO0lBQVIsV0FBUSxTQUFSOztJQUF5RTtJQUF6RSxXQUF5RSxTQUF6RTtJQUF3RztJQUFBOzs7O3NEQUQ1RztNQUFBO01BQUE7SUFBQTtJQUFBO0lBQWU7TUFBQTtNQUFBO0lBQUE7SUFBZjtFQUFBLGdDQUE4RCw4Q0FDMUQ7YUFBQTthQUFBOzRCQUFBLHlDQUFrSTtVQUFBLHVCQUM3SDs7SUFEMkI7SUFBaEMsV0FBZ0MsU0FBaEM7Ozs7b0JDREo7TUFBQTt3Q0FBQTtNQUFBO1FBQUE7TUFBQSx1Q0FBQTtNQUFBO0lBQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/employees/select-employee/select-employee.component.ngfactory.ts